export const MOUVEMENT_BACK_ERROR = {
  bordereau: ['identifiant_bordereau_oblig'],
} as const;

export const MOUVEMENT_FRONT_ERROR = {
  MOUVEMENT_BORDEREAU: 'Veuillez choisir un bordereau.',
  MOUVEMENT_EXERCICE: 'Veuillez choisir un exercice.',
  MOUVEMENT_ENTITE: 'Veuillez choisir une entité.',
  MOUVEMENT_IMPUTATION: 'Veuillez choisir une imputation.',
} as const;
